// extracted by mini-css-extract-plugin
export var inputGroupSm = "styles-module--input-group-sm--3_Meu";
export var inputGroupLg = "styles-module--input-group-lg--1u-q2";
export var logo = "styles-module--logo--2vMXP";